import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  @service
  schoolSchema;

  model() {
    let group = this.modelFor('group');
    return hash({
      group,
      learners: this.modelFor('group.insights').learners,
      includeFormer: this.modelFor('group.insights').includeFormer,
      genderField: this.schoolSchema.getLearnerGenderField(),
    });
  }
}
